import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-arrow-right-lined",
  "use": "rt-base-arrow-right-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-arrow-right-lined\"><path d=\"M286.1 135.8L662.3 512 286.1 888.2c-16.4 16.4-16.4 43.1 0 59.5s43.1 16.4 59.5 0l382.6-382.6c14.2-14.2 22-33 22-53.1s-7.8-38.9-22-53.1L345.6 76.3c-16.4-16.4-43.1-16.4-59.5 0-16.4 16.5-16.4 43.1 0 59.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/arrow-right-lined.svg
// module id = 1677
// module chunks = 137